import routes from './routes';
import SetRoutes from 'components/setRoutes';

const PromotionsPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default PromotionsPage;
